var ajax = require('./ajax');

/**
 * @function removeCJCookie
 * @description removes cje cookie if a user rejected the cookie consent
 */
function removeCJCookie() {
	const optanonAlertBoxClosed = getCookieValue('OptanonAlertBoxClosed');
	if (optanonAlertBoxClosed) {
		const optanonConsent = getCookieValue('OptanonConsent');
		if (SitePreferences.OPTANON_CONSENT && optanonConsent.includes(SitePreferences.OPTANON_CONSENT)) {
			// Delete cookie on both backend and client sides
			ajax.load({
				url: Urls.removeCJCookie
			});

			deleteCookie('cje', '/', window.location.hostname);
		}
	}
}

function getCookieValue(cookieName) {
	const name = cookieName + "=";
	const decodedCookie = decodeURIComponent(document.cookie);
	const cookiesArray = decodedCookie.split(';');
	for (let i = 0; i < cookiesArray.length; i++) {
		let cookie = cookiesArray[i].trim();
		if (cookie.indexOf(name) === 0) {
			return cookie.substring(name.length, cookie.length);
		}
	}
	return "";
  }

function deleteCookie(name, path, domain) {
	if (getCookieValue(name)) {
		document.cookie = name + '=' +
			((path) ? ';path=' + path : '') +
			((domain) ? ';domain=' + domain : '') +
			';expires=Thu, 01 Jan 1970 00:00:01 GMT';
	}
}
exports.removeCJCookie = removeCJCookie;
